"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hashCanvasValue = void 0;

const hash_1 = require("./hash");

function hashCanvasValue(value) {
  if (!(value === null || value === void 0 ? void 0 : value.geometry) || !(value === null || value === void 0 ? void 0 : value.text)) {
    return value;
  }

  const geometry = (0, hash_1.x64Hash128)(value.geometry);
  const text = (0, hash_1.x64Hash128)(value.text);
  return Object.assign(Object.assign({}, value), {
    text,
    geometry
  });
}

exports.hashCanvasValue = hashCanvasValue;